import fetch from '@/api/fetch'

/**
 * 计算退回商品
 */
export function calcRefundCommodityReq(params) {
  return fetch({
    url: '/v2/my/refund/calcRefundCommodity',
    method: 'post',
    params
  })
}
